export const HOME_CHAT_EVENT = "wilson:homeChat"

export interface HomeChatRequest {
    threadId?: string
    question?: string
}

export function isHomeChatRequest(value: unknown): value is HomeChatRequest {
    if (typeof value !== "object" || value === null) return false
    const { threadId, question } = value as Record<string, unknown>
    return (
        (threadId === undefined || typeof threadId === "string") &&
        (question === undefined || typeof question === "string")
    )
}

export const WORK_LINE_ON_PAGE = "[&_[data-pinned]]:bg-offwhite/40"

export type PartOfDay = "morning" | "afternoon" | "evening"

const AFTERNOON_STARTS_AT_HOUR = 12
const EVENING_STARTS_AT_HOUR = 17

export function partOfDay(now: Date): PartOfDay {
    const hour = now.getHours()
    if (hour < AFTERNOON_STARTS_AT_HOUR) return "morning"
    if (hour < EVENING_STARTS_AT_HOUR) return "afternoon"
    return "evening"
}

export function parseIsListOpen(raw: string): boolean {
    return raw !== "false"
}

export type DoneToday = "both" | "booked" | "emails"

export function todaySummaryParts({
    bookedCount,
    emailsSentCount,
}: {
    bookedCount: number
    emailsSentCount: number
}): { done: DoneToday | null } {
    if (bookedCount > 0 && emailsSentCount > 0) return { done: "both" }
    if (bookedCount > 0) return { done: "booked" }
    if (emailsSentCount > 0) return { done: "emails" }
    return { done: null }
}
